import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { changeEventForm } from 'src/actions/event'
import EventFormContent from 'src/containers/event/CreateEvent/EventFormContent/EventFormContent'
const CreateEvent = (props) => {
  const dispatch = useDispatch()
  const {
    params: { designNumber, designSlug }
  } = props

  useEffect(() => {
    if (designNumber) {
      dispatch(
        changeEventForm({
          flyer_design_number: designNumber,
          flyer_design_slug: designSlug
        })
      )
    }
  }, [designNumber, designSlug])

  return (
    <EventFormContent />
  )
}

CreateEvent.propTypes = {
  params: PropTypes.object
}

export default CreateEvent
